<section class="farms-panel">
  <h4>OEM farms</h4>
  <p class="muted small">
    Link a {{ providerLabel }} farm to a Harvest Mate farm. Farms and fields are
    separate — link fields to blocks in the section below.
  </p>

  @if (farmsUnavailable) {
  <div class="cnh-unavailable">
    Farm linking for {{ providerLabel }} is temporarily unavailable. It will be
    enabled once the vendor data license is active.
  </div>
  }

  @if (!farmsUnavailable && loading) {
  <div class="muted">Loading farms&hellip;</div>
  } @if (!farmsUnavailable && errorMessage) {
  <div class="error">{{ errorMessage }}</div>
  }

  @if (!farmsUnavailable && !loading && !errorMessage) {
  @if (farms.length === 0) {
  <div class="muted">No farms from {{ providerLabel }}.</div>
  } @if (farms.length > 0) {
  <!-- SRA003-502: one unified table, one row per farm; each row's action is
       Link or Unlink depending on its state. -->
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Farm</th>
        <th scope="col">Harvest Mate farm</th>
        <th scope="col">Status</th>
        <th scope="col"><span class="visually-hidden">Actions</span></th>
      </tr>
    </thead>
    <tbody>
      @for (f of farms; track f.oem_farm_id) {
      <tr>
        @if (rowFor(f); as state) {
        <td>{{ f.name || f.oem_farm_id }}</td>
        @if (isLinked(f)) {
        <td>{{ hmFarmLabel(f.linked_farm_id) }}</td>
        <td><span class="status-chip linked">Linked</span></td>
        <td>
          <button
            class="btn-small"
            type="button"
            (click)="unlink(f)"
            [disabled]="state.busy"
          >
            Unlink
          </button>
        </td>
        } @else if (isLinkedElsewhere(f)) {
        <!-- SRA003-524: claimed by another operator in the org. Privacy-aware —
             no identity, just shown as unavailable so it isn't offered (a link
             would 409). -->
        <td class="muted small">Linked by another operator</td>
        <td><span class="status-chip unlinked">Linked elsewhere</span></td>
        <td><span class="muted small">Unavailable</span></td>
        } @else {
        <td>
          <select [(ngModel)]="state.farmIdInput" [disabled]="state.busy">
            <option [ngValue]="undefined">Select a farm&hellip;</option>
            @for (grp of farmGroups; track $index) {
            <optgroup [label]="grp.growerName">
              @for (hm of grp.farms; track hm.id) {
              <option [ngValue]="hm.id" [disabled]="!!hm.linkedLabel">
                {{ hm.name }}@if (hm.linkedLabel) { — {{ hm.linkedLabel }}}
              </option>
              }
            </optgroup>
            }
          </select>
        </td>
        <td><span class="status-chip unlinked">Not linked</span></td>
        <td>
          <button
            class="btn-oem-primary"
            type="button"
            (click)="link(f)"
            [disabled]="state.busy"
          >
            Link
          </button>
        </td>
        }
        }
      </tr>
      }
    </tbody>
  </table>
  }
  }
</section>
